export default __webpack_public_path__ + "static/float_gradation_sp-9791ba040c7346c5befed734201ef20a.png";